/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { StudentEvaluationFeedback } from './studentEvaluationFeedback';

export type SubmissionEvaluationStudentFeedback = StudentEvaluationFeedback | null;
